import { GetIco } from '@/utils/icons'
import cn from 'classnames'
import { FC, useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import classes from './index.module.css'
import Moment from 'react-moment'
import { LicenseAndPaymentData } from '@/api/types/licenseAndPayment.types'
import { licenseAndPaymentApi } from '@/api/queries/licenseAndPayment'
import { isError } from '@/helpers/checkQuery'
import { useIsMinimizedMenu } from '@/hooks/useIsMinimizedMenu'
import { Tooltip } from 'antd'

interface LicenseAndPaymentButtonProps {
  className?: string
}

const LicenseAndPaymentButton: FC<LicenseAndPaymentButtonProps> = ({
  className,
}) => {
  const [data, setData] = useState<LicenseAndPaymentData>()
  const isMinimizedMenu = useIsMinimizedMenu();

  const handlerLoadData = () => {
    licenseAndPaymentApi
      .getData()
      .then((res) => {
        if (isError(res)) throw new Error()

        setData(res.data.data)
      })
      .catch((error: any) =>
        console.error('Ошибка загрузки данных о лицензиях и оплатах: ', error),
      )
  }

  // FIXME: uncomment this line
  // useEffect(() => handlerLoadData(), []) 

  return (
    <Tooltip title={isMinimizedMenu ? 'Лицензии и оплаты' : ''} placement='right'>
      <>
        <NavLink
          to="#" // FIXME: add "/license-and-payment"
          className={cn(classes.navLink, {[classes.center]: isMinimizedMenu}, className)}
          title={!isMinimizedMenu ? 'Лицензии и оплаты' : ''}
        >
          <GetIco icon="credit_card_2" className={classes.icon} />
          {
            !isMinimizedMenu && (
                <div>
                  <p
                    className={cn(classes.title, {
                      [classes.colorDanger]: data && data.closing_date !== null,
                    })}
                  >
                    Лицензии и оплаты
                  </p>
                  {data?.closing_date && (
                    <p
                      className={cn(
                        data.closing_date === null ? classes.subTitle : classes.subTitleDanger,
                      )}
                    >
                      Доступ закроется{' '}
                      <Moment date={data.closing_date} format="DD.MM.YYYY" withTitle />
                    </p>
                  )}
                </div>
            )
          }
        </NavLink>
      </>
    </Tooltip>
  )
}

export default LicenseAndPaymentButton
